// Conditional Sentry import - only loads if DSN is available
if (import.meta.env.VITE_SENTRY_DSN) {
  import('../sentry.client.config');
}
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { registerServiceWorker, setupInstallPrompt } from './utils/pwa';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

// Initialize PWA features
if (import.meta.env.PROD) {
  registerServiceWorker();
  setupInstallPrompt();
}

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);